export enum OrderCancellationStatus {
  notSet = 0,
  pending = 1,
  done = 2
}
